<div class="model-main">
  <button class="dialog-close" mat-dialog-close><svg xmlns="http://www.w3.org/2000/svg" width="27" height="27"
      viewBox="0 0 37 37" fill="none">
      <rect width="37" height="37" rx="18.5" fill="#747474" fill-opacity="0.2" />
      <path d="M12 25L25 12" stroke="#232930" stroke-width="2" />
      <path d="M25 25L12 12" stroke="#232930" stroke-width="2" />
    </svg></button>
  <div class="row m-0 otp-login">
    <div class="col-md-6 p-0 hide-on-mobile">
      <div class="sidebar-left" style="background: url(./assets/images/{{cs.city}}/login-sidebar.png); background-size: cover;">
        <p>{{'home.property_tax_managment_made_easy' | translate}}</p>
      </div>
    </div>
    <div class="col-md-6 p-0">
      <div class="login-form " *ngIf ="!isLoading; else loadingBlock">
        <h2 class="mb-4">
          <span class="mr-3 mst" (click)="backToLogin()"> <svg xmlns="http://www.w3.org/2000/svg" width="25" height="20" viewBox="0 0 25 20"
              fill="none">
              <path d="M2 10H25" stroke="black" stroke-width="2" />
              <path d="M8.49484 0.814453L2 9.90723L8.49484 19" stroke="black" stroke-width="2" />
            </svg></span>{{'home.otp_verification' | translate}}</h2>
        <p class="sub-heading mb-2">{{'home.please_enter_your_one_time_pwd' | translate}}
        </p>
       

        <div id="otp" class="inputs d-flex flex-row justify-content-center position-relative">
          <label class="otp">{{'home.otp' | translate}}<span class="required">*</span></label>
      <input [(ngModel)]="otp.code" required minlength="4" placeholder="{{'home.enter_otp' | translate}}" #code="ngModel"
             (ngModelChange)="error=''" class="form-control"
             [ngClass]="{'is-invalid': (code.invalid && (code.dirty || code.touched)) || error.length > 0}"
             (keydown.enter)="confirm()"
      >
        
      <div *ngIf="(code.invalid && (code.dirty || code.touched)) || error.length > 0;"
        class="invalid-tooltip">
     <span *ngIf="code.errors?.required">
      {{'home.otp_is_required' | translate}}
     </span>
     <span *ngIf="code.errors?.minlength">
      {{'home.otp_must_be_at_least_6_characters_long' | translate}}
     </span>
     <span *ngIf="code.valid && error.length > 0">
       {{error}}
     </span>
   </div>
        </div>




        

        <p class="text-center countdown">
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
            <path
              d="M9.92857 2C9.73913 2 9.55745 2.07525 9.42349 2.20921C9.28954 2.34316 9.21429 2.52485 9.21429 2.71429C9.21429 2.90373 9.28954 3.08541 9.42349 3.21936C9.55745 3.35332 9.73913 3.42857 9.92857 3.42857H14.2143C14.4037 3.42857 14.5854 3.35332 14.7194 3.21936C14.8533 3.08541 14.9286 2.90373 14.9286 2.71429C14.9286 2.52485 14.8533 2.34316 14.7194 2.20921C14.5854 2.07525 14.4037 2 14.2143 2H9.92857ZM12.0714 8.42857C12.2609 8.42857 12.4426 8.50383 12.5765 8.63778C12.7105 8.77174 12.7857 8.95342 12.7857 9.14286V13.4286C12.7857 13.618 12.7105 13.7997 12.5765 13.9336C12.4426 14.0676 12.2609 14.1429 12.0714 14.1429C11.882 14.1429 11.7003 14.0676 11.5664 13.9336C11.4324 13.7997 11.3571 13.618 11.3571 13.4286V9.14286C11.3571 8.95342 11.4324 8.77174 11.5664 8.63778C11.7003 8.50383 11.882 8.42857 12.0714 8.42857ZM20.6429 13.4286C20.6429 18.1621 16.805 22 12.0714 22C7.33786 22 3.5 18.1621 3.5 13.4286C3.5 8.695 7.33786 4.85714 12.0714 4.85714C16.805 4.85714 20.6429 8.695 20.6429 13.4286ZM19.2143 13.4286C19.2143 9.48357 16.0164 6.28571 12.0714 6.28571C8.12643 6.28571 4.92857 9.48357 4.92857 13.4286C4.92857 17.3736 8.12643 20.5714 12.0714 20.5714C16.0164 20.5714 19.2143 17.3736 19.2143 13.4286ZM19.72 5.06643C19.6541 4.99821 19.5753 4.94379 19.4881 4.90636C19.401 4.86892 19.3073 4.84922 19.2124 4.84839C19.1176 4.84757 19.0235 4.86564 18.9357 4.90156C18.848 4.93747 18.7682 4.99051 18.7011 5.05757C18.6341 5.12464 18.581 5.20439 18.5451 5.29218C18.5092 5.37996 18.4911 5.47402 18.492 5.56886C18.4928 5.6637 18.5125 5.75743 18.5499 5.84457C18.5874 5.93172 18.6418 6.01054 18.71 6.07643L20.1386 7.505C20.2049 7.57132 20.2837 7.62391 20.3704 7.65979C20.4571 7.69566 20.55 7.71411 20.6438 7.71407C20.7376 7.71404 20.8305 7.69553 20.9172 7.65959C21.0039 7.62366 21.0826 7.57101 21.1489 7.50464C21.2152 7.43828 21.2678 7.3595 21.3037 7.27281C21.3396 7.18612 21.358 7.09321 21.358 6.99939C21.358 6.90557 21.3395 6.81267 21.3035 6.72601C21.2676 6.63934 21.2149 6.5606 21.1486 6.49429L19.72 5.06571V5.06643Z"
              fill="#1A1A1A" />
          </svg> <span>{{countdown.minutes}}:{{countdown.seconds}}</span>
        </p>
        <button (click)="confirm()" class="btn btn-primary mb-4">{{'home.confirm' | translate}}</button>

        <p class="resend" *ngIf="!resendDisabled">
          {{'home.didn’t_receive_the_otp' | translate}} <span (click)="resend()" class="resend"
           >{{'home.resend' | translate}}</span></p>

      </div>
    </div>
  </div>
</div>
<ng-template #loadingBlock>
  <div class="loader__general text-center">
    <div class="spinner-border" role="status">
      <span class="sr-only">{{'home.loading' | translate }}</span>
    </div>
  </div>
</ng-template>